import { LINKS } from "../../../config/links";

import { ReactComponent as OneSideIcon } from "./icons/cruiseIcons/1sideIcon.svg";
import { ReactComponent as TwoSideIcon } from "./icons/cruiseIcons/2sidesIcon.svg";
import { ReactComponent as RoundIcon } from "./icons/cruiseIcons/RoundIcon.svg";
import { ReactComponent as CruiseBikeIcon } from "./icons/cruiseIcons/bicycle-54.svg";
import { ReactComponent as CruiseTrailerIcon } from "./icons/cruiseIcons/bicycle-trailer-svgrepo-com.svg";
import { ReactComponent as VipIcon } from "./icons/cruiseIcons/vip.svg";

import { ReactComponent as BikeIcon } from "./icons/bikesIcons/bicycle-54.svg";
import { ReactComponent as ElectricBikeIcon } from "./icons/bikesIcons/bicycle-electric-svgrepo-com.svg";
import { ReactComponent as TrailerIcon } from "./icons/bikesIcons/bicycle-trailer-svgrepo-com.svg";
import { ReactComponent as SeatIcon } from "./icons/bikesIcons/car-seat-with-seatbelt-svgrepo-com.svg";
import { ReactComponent as HelmetIcon } from "./icons/bikesIcons/bicycle-helmet-svgrepo-com.svg";

const ICONS = {
    oneSide: OneSideIcon,
    twoSide: TwoSideIcon,
    round: RoundIcon,
    cruiseBike: CruiseBikeIcon,
    cruiseTrailer: CruiseTrailerIcon,
    vip: VipIcon,

    bike: BikeIcon,
    electricBike: ElectricBikeIcon,
    trailer: TrailerIcon,
    seat: SeatIcon,
    helmet: HelmetIcon,
};

export const PRICE_TABLES = {
    cruises: {
        wrapperId: "cennik-rejsu",
        titleKey: "cruises.title",

        columns: [
            { key: "normal", labelKey: "cruises.columns.normal" },
            { key: "discount", labelKey: "cruises.columns.discount" },
        ],

        rows: [
            { key: "oneWay", icon: "oneSide", values: ["17 PLN", "14 PLN"] },
            { key: "twoWays", icon: "twoSide", values: ["34 PLN", "28 PLN"] },
            { key: "roundTrip", icon: "round", values: ["35 PLN", "28 PLN"] },
            { key: "passengerWithBike", icon: "cruiseBike", values: ["27 PLN", "-"] },
            { key: "bikeTrailerTransport", icon: "cruiseTrailer", values: ["15 PLN", "-"] },
            { key: "vipRental", icon: "vip", values: ["450 PLN", "-"] },
        ],

        notes: {
            linesKeys: [
                "cruises.notes.childFree",
                "cruises.notes.groupsReservation",
                "cruises.notes.groupsNegotiation",
                "cruises.notes.vatInvoice",
            ],
            strongLineIndex: 0,
        },

        contactBlocks: [
            {
                type: "contact",
                headerKey: "cruises.contact.header",
                textKey: "cruises.contact.text",
                links: [
                    { kind: "phone", href: LINKS.phone, displayKey: "cruises.contact.phoneDisplay" },
                    { kind: "email", href: LINKS.email, displayKey: "cruises.contact.emailDisplay" },
                ],
            },
            {
                type: "location",
                headerKey: "cruises.czorsztyn.header",
                textKeys: ["cruises.czorsztyn.name", "cruises.czorsztyn.street", "cruises.czorsztyn.city"],
                links: [
                    { kind: "maps", href: LINKS.mapsCzorsztyn, labelKey: "cruises.actions.navigateGoogleMaps" },
                    { kind: "tour", href: LINKS.tourCzorsztyn, labelKey: "cruises.actions.virtualTourCzorsztyn" },
                ],
            },
            {
                type: "location",
                headerKey: "cruises.niedzica.header",
                textKeys: ["cruises.niedzica.name", "cruises.niedzica.street", "cruises.niedzica.city"],
                links: [
                    { kind: "maps", href: LINKS.mapsNiedzica, labelKey: "cruises.actions.navigateGoogleMaps" },
                    { kind: "tour", href: LINKS.tourNiedzica, labelKey: "cruises.actions.virtualTourNiedzica" },
                ],
            },
        ],
        icons: ICONS,
    },

    bikesRental: {
        wrapperId: "cennik-wypozyczalni",
        titleKey: "bikesRental.title",

        columns: [
            { key: "upTo3h", labelKey: "bikesRental.columns.upTo3h" },
            { key: "fullDay", labelKey: "bikesRental.columns.fullDay" },
        ],

        rows: [
            { key: "classicBike", icon: "bike", values: ["50 PLN", "60 PLN"] },
            { key: "electricBike", icon: "electricBike", values: ["150 PLN", "200 PLN"] },
            { key: "trailer", icon: "trailer", values: ["-", "60 PLN"] },
            { key: "childSeat", icon: "seat", values: ["-", "30 PLN"] },
            { key: "helmet", icon: "helmet", values: ["-", "10 PLN"] },
        ],

        notes: {
            linesKeys: ["bikesRental.notes.dayDefinition", "bikesRental.notes.freeGondola"],
            strongLineIndex: 1,
        },

        contactBlocks: [
            {
                type: "contact",
                headerKey: "bikesRental.contact.header",
                textKey: "bikesRental.contact.text",
                links: [
                    { kind: "phone", href: LINKS.bikesRentalPhone, displayKey: "bikesRental.contact.phoneDisplay" },
                    { kind: "email", href: LINKS.bikesRentalEmail, displayKey: "bikesRental.contact.emailDisplay" },
                ],
            },
            {
                type: "locationSingle",
                headerKey: "bikesRental.address.header",
                textKeys: ["bikesRental.address.name", "bikesRental.address.street", "bikesRental.address.city"],
                links: [{ kind: "maps", href: LINKS.bikesRentalMaps, labelKey: "bikesRental.address.navigate" }],
            },
        ],

        icons: ICONS,
    },
};